import transformToCamelCase from './toCamelCaseTransformer';

export default function transformCampaignInfo(campaignInfo) {
  const snakeCaseCampaignInfo = transformToCamelCase(campaignInfo);
  const { impressionTrackerLink } = snakeCaseCampaignInfo;
  return {
    ...snakeCaseCampaignInfo,
    hasTracker: Boolean(impressionTrackerLink),
    impressionTrackerLink: impressionTrackerLink || '',
  };
}
